import { mergeStateParts } from 'Modules/core/redux';

import { pagination } from './pagination';
import { storage } from './storage';


export const state = mergeStateParts('data', {
    pagination,
    storage,
});
